import React, { useEffect } from 'react'
import { Amplify } from 'aws-amplify'

import { UserContextProvider } from './context/UserContextProvider'
import config from './config';

import { Authenticator, withAuthenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'
import { cognitoComponents } from './cognito/cognitoComponents'

import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom'

import Footer from './components/Footer'
import Reports from './pages/Reports'
import DailyReport from './pages/DailyReport'
import SearchResults from './pages/SearchResults'
import Subscribe from './pages/Subscribe'

import awsExports from './aws-exports'
Amplify.configure(awsExports)


function App({ip, isWhitelisted}) {
  const orgName = config.orgName


  const HomeLayout = () => {
    return (
      <div>
        <Outlet />
      </div>
    )
  }
  
  const router = createBrowserRouter([
    { path: '/', element: <DailyReport /> },
    {
      path: '/home',
      element: <HomeLayout />,
      children: [ 
        { index: true, element: <DailyReport /> }, // Default route for '/home'
        { path: 'reports', element: <Reports /> },
        { path: 'daily/:id?', element: <DailyReport /> },
        { path: 'subscribe', element: <Subscribe /> },
      ]
    },
    { path: 'search/:term?', element: <SearchResults /> },
  ])

  useEffect(() => {
    // Add a banner to the login page
    const bannerDiv = document.createElement('div')
    bannerDiv.className = 'login-banner'

    const tabList = document.querySelector('.amplify-tabs')
    if (tabList) {
        tabList.parentNode.insertBefore(bannerDiv, tabList)
    }
  }, [])

  
  return (
    <Authenticator components={cognitoComponents}>
      {({ signOut, user }) => (
      <div>
          <UserContextProvider initialOrgName={orgName} initialUser={user} signOut={signOut} initilisWhitelisted={false}>
            <RouterProvider router={router} />
            <br/><br/><br/>
            <Footer />
          </UserContextProvider>
        </div>
      )}
    </Authenticator>
  )
}

// export default withAuthenticator(App)
export default App
